import * as React from 'react';
import { BrowserRouter, Route } from 'react-router-dom';
import MainComp from '../containers/main/index';
import ListComp from '../containers/list/index';
import NewsComp from '../containers/news/index';

class Router extends React.Component {
    public render() {
        return (
            <BrowserRouter>
                <Route exact={true} path="/" component={MainComp} />
                <Route exact={true} path="/listPage/:id" component={ListComp} />
                <Route exact={true} path="/news/:id" component={NewsComp} />
            </BrowserRouter>
        )
    }
}

export default Router;


// WEBPACK FOOTER //
// ./src/routes/router.tsx